/**
 * App-wide z-index scale (matches :root in index.css).
 * Higher values paint above lower. Use these for inline zIndex props (e.g. glintly Modal).
 */
export const Z_INDEX = {
  base: 0,
  raised: 1,
  sticky: 10,
  /** Dashboard sidebar rail (below fixed headers) */
  sidebar: 100,
  /** Fixed marketing / dashboard top bars */
  navbar: 1000,
  /** Menus and popovers anchored to the navbar */
  dropdown: 1100,
  /** Full-screen blocking spinners (below modals so dialogs can still open) */
  loading: 9000,
  /** Toasts — below modals so open dialogs are never covered */
  toast: 10000,
  /** Dialogs, auth overlays, glintly Modals — above toasts */
  modal: 11000,
};
